module.exports = __webpack_public_path__ + "media/images/official/special_workcation_13-cefa4eec0dbdaaf17c371eb1af6cf0aa.jpg";